

angular.module('persistent', [])
	.service('ClassFactory', Persistent.ClassFactory)
	.service('Classes', Persistent.Classes)
	.service('CurrentUser', Persistent.CurrentUser)
	.service('CurrentUserPrefs', Persistent.CurrentUserPrefs)
	.factory('SimpleObservable', function() {return Persistent.SimpleObservable;})
	
